import CT from '@marketplace-ai/tags';
import { Column } from '~/components';

const TAGS = CT.employer.msaasListings.costCalculator;

const moneyFormatter = (data: string) =>
  '$' + Number(data).toLocaleString('en-US', { minimumFractionDigits: 2 });

export const generateTableColumns = (tableIdx: number): Column[] => [
  { label: 'Shift Type', data: 'shiftType', cyTag: TAGS.shiftType + tableIdx },
  { label: 'Shifts', data: 'count', cyTag: TAGS.count + tableIdx },
  {
    label: 'RVUs',
    data: 'rvus',
    cyTag: TAGS.rvus + tableIdx,
  },
  {
    label: 'Hourly Rate',
    data: 'hourlyRate',
    cyTag: TAGS.hourlyRate + tableIdx,
    formatter: moneyFormatter,
  },
  {
    label: 'Price/RVU',
    data: 'pricePerRvu',
    cyTag: TAGS.pricePerRvu + tableIdx,
    formatter: moneyFormatter,
  },
  {
    label: 'Hours/Shift',
    data: 'hoursPerShift',
    cyTag: TAGS.hoursPerShift + tableIdx,
  },
  {
    label: 'Cost/Shift',
    data: 'costPerShift',
    cyTag: TAGS.costPerShift + tableIdx,
    formatter: moneyFormatter,
  },
  {
    label: 'Subtotal',
    data: 'subTotal',
    cyTag: TAGS.subTotal + tableIdx,
    formatter: moneyFormatter,
  },
];
